export const learnPageTabsIds = {
  howNorthWorks: 'how-north-works',
  goalTemplates: 'goal-templates'
}

export const goalTemplatesFilterDefaultState = {
  teams: [{ label: 'All', id: -1 }],
  roles: [{ label: 'All', id: -1 }],
  companies: [{ label: 'All', id: -1 }]
}
